export default "__VITE_ASSET__16317ed5__"